import { forwardRef } from "react";

import { PickerTimeProps } from "antd/lib/date-picker/generatePicker";
import { clsx } from "clsx";
import { Dayjs } from "dayjs";

import { RVDatePickerDayJSFacade } from "../RVDatePickerDayJSFacade/RVDatePickerDayJSFacade";

import styles from "./RVTimePicker.module.scss";

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

/**
 * Regal Voice Time Picker component using Dayjs and Ant Design.
 *
 * @remarks
 * This is a styled wrapper around the Ant Design TimePicker, using Dayjs for time management.
 * Use this for all time picking needs in the app for consistency.
 *
 * @param props - All AntD PickerTimeProps except 'picker', which is set to 'time'.
 */
export const RVTimePicker = forwardRef<any, Optional<PickerTimeProps<Dayjs>, "picker">>((props: any, ref) => {
    return (
        <RVDatePickerDayJSFacade
            picker="time"
            {...props}
            mode={undefined}
            ref={ref}
            className={clsx(styles.timepicker, props.className || "")}
            popupClassName={clsx(styles.timepicker, props.popupClassName || "")}
        />
    );
});

RVTimePicker.displayName = "RVTimePicker";
